import { DictionaryEntries } from './dictionary-entries';

export const FR: DictionaryEntries = {
  '&': '&',
  'AllBactionitemsmustbeclosed.': 'Tous les éléments d\'action B doivent être fermés',
  '3rdPartyexternal': 'Tiers (externe)',
  'ABChecklist': 'Liste de contrôle AB',
  'ABChecklistfor': 'Liste de contrôle AB pour',
  'ACTIONS': 'ACTIONS',
  'AChecklist': 'Liste de contrôle A',
  'Action': 'Action',
  'ActionConfirmation': 'Êtes-vous sûr de vouloir effectuer cette action?',
  'ActionItemAssignee': 'Assigné à l\'élément d\'action',
  'ActionItemisneededtocompletequestion': 'Un élément d\'action est nécessaire pour compléter la question',
  'ActionItems': 'Éléments d\'action',
  'ActionIsRequired': 'Une action est requise',
  'ActionWillBeTransferred': 'L\'action sera transférée aux opérations',
  'Actions': 'Actions',
  'Actionwillbetransferredtooperations': 'L\'élément sera transféré aux opérations',
  'Active': 'Actif',
  'Add': 'Ajouter',
  'AddABChecklisttoProject': 'Ajouter une liste de contrôle AB au projet',
  'AddABChecktoEndDevice': 'Ajouter un contrôle AB à l\'appareil final',
  'AddComment': 'Ajouter un commentaire',
  'AddFeedback': 'Ajouter un retour',
  'AddGroup': 'Ajouter un groupe',
  'AddNew': 'AJOUTER NOUVEAU',
  'AddQuestion': 'Ajouter une question',
  'AddRedLining': 'Ajouter un marquage rouge',
  'AddSignature': 'AJOUTER UNE SIGNATURE',
  'AddTemplate': 'Ajouter un modèle',
  'AddUser': 'Ajouter un utilisateur',
  'AddVersion': 'Ajouter une version',
  'AddYellowLining': 'Ajouter un marquage jaune',
  'Addactionitem': 'Ajouter un élément d\'action',
  'AddtoEAM': 'Ajouter à EAM',
  'Alert': 'Alerte',
  'Alltherelatedsectionssubsectionsitemswillberemoved': 'Toutes les sections | sous-sections | éléments associés seront supprimés',
  'Alltherelatedsubsectionsitemswillberemoved': 'Toutes les sous-sections | éléments associés seront supprimés',
  'SendAllNotificationsToApproversInstruction': '*Si cochée, l\'approbateur final recevra toutes les notifications',
  'AllP3actionmustbeclosedtosubmitforapproval': 'Toutes les actions {{P3Label}} doivent être fermées pour soumettre à approbation',
  'AllowAIOwnerToAttach': 'Autoriser le propriétaire de l\'IA à joindre',
  'AllowAIOwnerToAttachInstruction': 'Si cochée, permet au propriétaire de l\'élément d\'action de joindre des fichiers quel que soit le statut de l\'IA tant que le PSSR n\'est pas fermé',
  'AllowApproverToSubmitForApproval': 'Autoriser l\'approbateur final à soumettre pour approbation',
  'AllowLeadsDeleteQuestions': 'Autoriser les chefs à supprimer des questions',
  'AllowMembersCompletePSSR': 'Autoriser les membres à compléter le PSSR',
  'AllowMembersToCompletePSSR': 'Autoriser les membres à compléter le PSSR',
  'AllowMultiApprover': 'Autoriser plusieurs approbateurs',
  'AllowNAResponses': 'Autoriser les réponses N/A',
  'AllowWetSignature': 'Autoriser la signature manuscrite PSSR',
  'Allpages': 'Toutes les pages',
  'Alltherelated': 'Tous les éléments associés',
  'Alltherelateditemswillberemoved': 'Tous les éléments associés seront supprimés',
  'AngularTemplatedocumentation': 'Documentation du modèle Angular',
  'Answer': 'Réponse',
  'AnswerallquestionsandsignaturestoCompletethePSSR': 'Répondez à toutes les questions et signatures pour compléter le {{PssrTitle}}',
  'AnswerallquestionssignaturestoCompletethePSSR': 'Répondez à toutes les questions et signatures pour compléter le {{PssrTitle}}',
  'Answerwillbecleared': 'La réponse sera effacée',
  'Approve': 'Approuver',
  'Approvebywetsignature': 'Approuver par signature manuscrite',
  'Approved': 'Approuvé',
  'ApprovedOn': 'Approuvé le',
  'AreyousureyouwanttodeleteABChecklistbelow': 'Êtes-vous sûr de vouloir supprimer la liste de contrôle AB ci-dessous',
  'AreyousureyouwanttodeleteSubCategory': 'Êtes-vous sûr de vouloir supprimer la sous-catégorie',
  'Area': 'Zone',
  'Areyousureyouwanttodelete': 'Êtes-vous sûr de vouloir supprimer',
  'AreyousureyouwanttodeleteTaskPlanbelow': 'Êtes-vous sûr de vouloir supprimer le plan de tâches ci-dessous',
  'AssignedToLeadFinalApprover': 'Assigné au chef / approbateur final',
  'Assignedto': 'Assigné à',
  'Assignedtome': 'Assigné à moi',
  'Assignee': 'Assigné',
  'Assignto': 'Assigner à',
  'Attach': 'Joindre',
  'AttachedFiles': 'Fichiers joints',
  'AutoLoadImages': 'Chargement automatique des images',
  'Autoclosems': 'Fermeture automatique (ms)',
  'Available': 'Disponible',
  'BChecklist': 'Liste de contrôle B',
  'BUAdmin': 'Administrateur BU',
  'BUAdmins': 'Administrateurs BU',
  'Back': 'Retour',
  'BacktoSubCategoryList': 'Retour à la liste des sous-catégories',
  'BacktoTaskPlan': 'Retour au plan de tâches',
  'BackToList': 'Retour à la liste',
  'Backto': 'Retour à',
  'BacktoABChecksList': 'Retour à la liste des contrôles AB',
  'BacktoAreaList': 'Retour à la liste des zones',
  'BacktoGroupList': 'Retour à la liste des groupes',
  'BacktoList': ' Retour à la liste',
  'BacktoProjectDetail': 'Retour aux détails du projet',
  'BacktoProjectList': 'Retour à la liste des projets',
  'BacktoTaskPlanManage': 'Retour à la gestion du plan de tâches',
  'Bug': 'Bogue',
  'BuildNumber': 'Numéro de build',
  'BusinessUnit': 'Unité d\'affaires',
  'BusinessUnitisrequired': 'L\'unité d\'affaires est requise',
  'BusinessUnits': 'Unités d\'affaires',
  'By': 'Par ',
  'ByDefaultProject': 'Par défaut est \'Projet\'',
  'CCCORR': 'PSSR / CCC / ORR',
  'CanOnlyPerformAttachments': 'Peut uniquement effectuer des pièces jointes',
  'Cancel': 'Annuler',
  'Canceled': 'Annulé',
  'CaptureSignature': 'Capturer la signature',
  'Categories': 'Catégories',
  'ChangeRequestApproved': 'Demande de changement approuvée',
  'ChangeRequestDenied': 'Demande de changement refusée',
  'Chevron': 'Chevron',
  'ChevronCorporationAllrightsreserved': 'Chevron Corporation. Tous droits réservés.',
  'ChevronDirectory': 'Annuaire Chevron',
  'ChevronDirectory/SharedUsers': 'Annuaire Chevron / Utilisateurs partagés',
  'ChevronIE': 'Chevron I&E',
  'ChevronSFT': 'Chevron SFT',
  'Clear': 'Effacer',
  'ClearFilter': 'Effacer le filtre',
  'ClearQuestion': 'Effacer la question',
  'ClearSelection': 'Effacer la sélection',
  'Close': 'Fermer',
  'CloseProjWarning': 'Voulez-vous fermer ce projet?',
  'CloseProject': 'Fermer le projet',
  'Closed': 'Fermé',
  'ClosedBy': 'Fermé par',
  'ClosedOn': 'Fermé le',
  'Code': 'Code',
  'ComissionDate': 'Date de mise en service',
  'Comment': 'Commentaire',
  'Commentgoeshere': 'Le commentaire va ici',
  'Commentisneededtocompletequestion': 'Un commentaire est nécessaire pour compléter la question',
  'CompleteTranslation': 'Compléter la traduction',
  'Completed': 'Complété',
  'CompletedQuestions': 'Questions complétées',
  'ConfigureActionItem': 'Configurer l\'élément d\'action',
  'Confirm': 'Confirmer',
  'ConfirmDeleteHeader': 'Confirmer la suppression',
  'ConfirmDeleteMessage': 'Vous êtes sur le point de supprimer cet élément, voulez-vous continuer?',
  'ConfirmDeletePSSRFileHeader': 'Confirmer la suppression',
  'ConfirmDeletePSSRFileMessage': 'Le fichier <b>{{fileName}}</b> sera définitivement supprimé, continuer?<br/>',
  'ConfirmPSSRApprovalHeader': '',
  'ConfirmPSSRApprovalMessage': 'Êtes-vous sûr de vouloir l\'approuver?',
  'ConfirmPSSRReOpenMessage': 'Êtes-vous sûr de vouloir rouvrir ce PSSR?',
  'ConfirmPSSRReOpenHeader': '',
  'ConfirmRejectionHeader': 'Confirmer le rejet',
  'ConfirmRejectionMessage': 'Si vous rejetez l\'élément d\'action, vous ne pourrez pas approuver ce PSSR. Vous devrez changer le statut à fin de visite en cliquant sur le bouton <b>{{actionsButton}}\'s</b> en bas de la page.',
  'ConfirmTranslationComplete': 'Êtes-vous sûr que le titre, la description, les éléments d\'action et les commentaires ont été traduits?',
  'Confirmdelete': 'Confirmer la suppression',
  'Confirmtoproceed': 'Veuillez <b>Confirmer</b> pour continuer',
  'ContinueConfirmation': 'Voulez-vous continuer?',
  'Contractor': 'Contractant',
  'CopiedImage': 'Image <b>{{docName}}</b> a été copiée',
  'Copy': 'Copier',
  'CopyEquipmentstoProject': 'Copier les équipements vers le projet',
  'CopyImage': 'Copier l\'image',
  'CopyImageError': 'Erreur de copie d\'image',
  'CopyfromProject': 'Copier depuis le projet',
  'CopyingImage': 'Copie d\'image en cours...',
  'Copyto': 'Copier vers',
  'CostCode': 'Code de coût',
  'Create': 'Créer',
  'CreateNewItem': 'Créer un nouvel élément',
  'CreateBusinessUnit': 'Créer une unité d\'affaires',
  'CreateGroup': 'Créer un groupe',
  'CreateNew': 'Créer nouveau',
  'CreateNewSubCategory': 'Créer une nouvelle sous-catégorie',
  'CreatePSSR': 'Créer {{PssrTitle}}',
  'CreatePSSRCCC': 'Créer PSSR / CCC',
  'CreatePSSRCCCORR': 'Créer PSSR / CCC / ORR',
  'CreatePSSRORR': 'Créer PSSR / ORR',
  'CreateProject': 'Créer un projet',
  'CreateSubCategory': 'Créer une sous-catégorie',
  'CreateTraining': 'Créer une formation',
  'CreateUser': 'Créer un utilisateur',
  'CreatedBy': 'Créé par',
  'CreatedOn': 'Créé le',
  'DBVersion': 'Version DB',
  'Date': 'Date',
  'DateCaptured': 'Date de capture',
  'Dates': 'Dates',
  'Default': 'Par défaut',
  'DefaultSummarySignatureDisclaimer': 'Clause de non-responsabilité de signature de résumé par défaut',
  'DefaultWalkdownSignatureDisclaimer': 'Clause de non-responsabilité de signature de walkdown par défaut',
  'Delete': 'Supprimer',
  'DeleteActionItem': 'Supprimer l\'élément d\'action',
  'DeleteDevice': 'Acceptez-vous de supprimer l\'appareil sélectionné',
  'DeleteEndDevice': 'Supprimer l\'appareil final',
  'DeleteEquipment': 'Supprimer l\'équipement',
  'DeleteEquipmentTemplateGroup': 'Supprimer le groupe de modèles d\'équipement',
  'DeleteManufacturerModel': 'Supprimer le fabricant - modèle',
  'DeleteProject': 'Cette action entraînera la suppression de ce projet et de tous les PSSR impliqués. Voulez-vous continuer?',
  'DeleteTaskPlanSection': 'Supprimer la section du plan de tâches',
  'DeleteTaskPlanSubSection': 'Supprimer la sous-section du plan de tâches',
  'DeleteselectedEquipmentTemplateGroup': 'Acceptez-vous de supprimer le groupe de modèles d\'équipement sélectionné',
  'Description': 'Description',
  'DescriptionScope': 'Description et portée',
  'Descriptioninputwasalreadyused': 'La saisie de description a déjà été utilisée',
  'Descriptionisrequired': 'La description est requise',
  'DeviceType': 'Type d\'appareil',
  'DeviceTypeEAM': 'Type d\'appareil - Nom EAM - Description EAM',
  'Disabled': 'Désactivé',
  'Discard': 'Abandonner',
  'DisplayRichEditor': 'Afficher l\'éditeur enrichi',
  'Documents': 'Documents',
  'Download': 'Télécharger',
  'DownloadError': 'Erreur de téléchargement de fichier',
  'DownloadingDocument': 'Téléchargement du document...',
  'DoyouagreetoDeleteselectedManufacturerModel': 'Acceptez-vous de supprimer le fabricant - modèle sélectionné',
  'DoyouagreetoDeleteselectedequipment': 'Acceptez-vous de supprimer l\'équipement sélectionné',
  'DoyouagreetoRemoveselectedparticipant': 'Acceptez-vous de supprimer le participant sélectionné',
  'Draft': 'Brouillon',
  'DraftCreatedOn': 'Brouillon créé le',
  'Dropdown': 'Menu déroulant',
  'DueDate': 'Date d\'échéance',
  'RequireActionItemDueDateInstruction': 'Si cochée, la date d\'échéance des éléments d\'action sera obligatoire',
  'EAMClass': 'Classe EAM',
  'EAMCriticality': 'Criticité EAM',
  'EAMDepartment': 'Département EAM',
  'EAMDescription': 'Description EAM',
  'EAMName': 'Nom EAM',
  'EAMType': 'Type EAM',
  'ENDDEVICESPECIFICABCHECKLISTS': 'LISTES DE CONTRÔLE AB SPÉCIFIQUES À L\'APPAREIL FINAL',
  'EQUIPMENT': 'ÉQUIPEMENT',
  'Edit': 'Modifier',
  'EditBusinessUnit': 'Modifier l\'unité d\'affaires',
  'EditGroup': 'Modifier le groupe',
  'EditImageError': 'Erreur de modification d\'image',
  'EditOrganization': 'Modifier l\'organisation',
  'EditParticipant': 'Modifier le participant',
  'EditProject': 'Modifier le projet',
  'EditRedLining': 'Modifier le marquage rouge',
  'EditSubCategory': 'Modifier la sous-catégorie',
  'EditTaskPlanSection': 'Modifier la section du plan de tâches',
  'EditYellowLining': 'Modifier le marquage jaune',
  'Email': 'Email',
  'EndDevice': 'Appareil final',
  'EndDeviceList': 'Liste des appareils finaux',
  'EndDeviceTemplate': 'Modèle d\'appareil final',
  'EndDevices': 'Appareils finaux',
  'English': 'Anglais',
  'EnglishTranslationInProgress': 'Traduction anglaise en cours',
  'Equipment': 'Équipement',
  'EquipmentGroup': 'Groupe d\'équipement',
  'EquipmentList': 'Liste d\'équipements',
  'EquipmentTemplate': 'Modèle d\'équipement',
  'EquipmentTemplateGroup': 'Groupe de modèles d\'équipement',
  'EquipmentTemplateGroups': 'Groupes de modèles d\'équipement',
  'EquipmentTemplates': 'Modèles d\'équipement',
  'EraseLocalData': 'Effacer les données locales',
  'ErrorImageEditMessage': 'Il n\'a pas été possible d\'ouvrir l\'image à modifier',
  'ErrorImageMessage': 'Il n\'a pas été possible de copier l\'image',
  'ErrorImageUndoMessage': 'Il n\'a pas été possible d\'annuler l\'image',
  'EventLabel': 'Étiquette de nom d\'événement',
  'EventName': 'Nom de l\'événement',
  'ExistingNonChevronShared': 'Non-Chevron/Partagé existant',
  'ExportABChecklistsasPDF': 'Exporter les listes de contrôle AB en PDF',
  'ExportExcel': 'Exporter vers Excel',
  'Facility': 'Installation',
  'FacilityHierarchy': 'Hiérarchie d\'installation',
  'FacilityNo': 'Installation #',
  'FacilityOperationTeam': 'Équipe d\'exploitation de l\'installation',
  'Factory': 'Usine',
  'Featurerequest': 'Demande de fonctionnalité',
  'Feedback': 'Support',
  'FeedbackScreen': 'Écran de support',
  'Fieldisrequired': 'Ce champ est requis',
  'FileDuplicate': 'Le document que vous essayez de télécharger existe déjà. Veuillez cliquer sur le bouton Annuler pour annuler le téléchargement ou sur le bouton Télécharger pour remplacer le document existant',
  'Files': 'Fichiers',
  'FilesUploaded': 'Les fichiers ont été téléchargés avec succès',
  'FilesUploadedWithWarning': 'Certains fichiers ont été téléchargés avec succès. Veuillez réessayer.',
  'FillAndSave': 'Veuillez remplir les champs marqués comme requis. Veuillez cliquer sur Enregistrer.',
  'Filter': 'Filtre',
  'FilterKMSListbyStatus': 'Filtre : Liste KMS par statut',
  'FilterNumberofKMSItemsreturned': 'Filtre : Nombre d\'éléments KMS retournés',
  'FilteredActionItemsInitialWarning': ' La page est filtrée par défaut sur l\'utilisateur actuel et le statut ouvert',
  'FinalApproval': 'Approbation finale',
  'FinalApprover': 'Approbateur final',
  'RequireFinalApproverBeforeInitiationInstruction': 'Si cochée, le PSSR nécessitera un approbateur final pour l\'initier',
  'FinalApproverPresent': 'Si l\'approbateur est marqué présent, la signature finale peut être fournie sur l\'appareil, sinon soumettre pour approbation et synchroniser',
  'FinalApproverSignature': 'Signature de l\'approbateur final',
  'FoundImages': 'Images trouvées',
  'FullName': 'Nom complet',
  'GENERALINFORMATION': 'INFORMATION GÉNÉRALE',
  'GeneralInformation': 'Information générale',
  'GeneratePSSR': 'Générer {{PSSRLabel}}',
  'GetEAMLoadsheet': 'Obtenir la feuille de chargement EAM',
  'GetEquipmentList': 'Obtenir la liste d\'équipements',
  'GoBack': 'Retourner',
  'Group': 'Groupe',
  'GroupName': 'Nom du groupe',
  'GroupNames': 'Noms de groupes',
  'UserGroups': 'Groupes d\'utilisateurs',
  'Hi': 'Bonjour',
  'HideCode': 'Masquer le code',
  'HierarchyLabel1': 'Étiquette de hiérarchie 1',
  'HierarchyLabel2': 'Étiquette de hiérarchie 2',
  'HierarchyLabel3': 'Étiquette de hiérarchie 3',
  'HierarchyLabel3show': 'Étiquette de hiérarchie 3 (afficher)',
  'I': 'Je',
  'ID': 'ID',
  'Iagree': 'Je suis d\'accord',
  'IagreethatallPSSRchecklistitems': 'Je confirme que tous les éléments de la liste de contrôle PSSR et tous les éléments d\'action nécessaires à un démarrage sûr ont été enregistrés avec précision',
  'Idontagree': 'Je ne suis pas d\'accord',
  'Image': 'Image',
  'ImageCaption': 'Légende',
  'ImageCapture': 'Capture d\'image',
  'Images': 'Images, Dessins PSI',
  'ImplementationInProgress': 'Mise en œuvre en cours',
  'ImplementationInProgressEdit': 'Modification de la mise en œuvre en cours',
  'ImportSharedUser': 'Importer un utilisateur partagé',
  'ImportMOCActions': 'Importer des éléments d\'action MOC',
  'InProgress': 'En cours',
  'Inactive': 'Inactif',
  'IncludeProjectTeam': 'Inclure les membres de l\'équipe du projet',
  'Info': 'Info',
  'Initiate': 'Initier',
  'Initiated': 'Initié',
  'InitiatedOn': 'Initié le',
  'Input': 'Entrée',
  'InputSharedUserEmail': 'Saisir l\'email de l\'utilisateur partagé',
  'InputdescriptionfornewSection': 'Saisir la description pour la nouvelle section',
  'Instructions': 'Instructions',
  'InternalError': 'Erreur interne',
  'IsAdmin': 'Est administrateur',
  'IsExternalUser': 'Est un utilisateur externe',
  'IsSectionOrderEnabled': 'Activer l\'ordre personnalisé pour les sections',
  'ItemCode': 'Code d\'article',
  'ItemCodeMsg': '- Code d\'article: <b>',
  'ItemDescriptionMsg': '</b><br/> - Description de l\'article: <b>',
  'Itemwillbetransferredtooperations': 'L\'élément sera transféré aux opérations',
  'Iteration': 'Itération',
  'KMSInstruction': 'Recherchez par un numéro MOC spécifique (gauche) ou sélectionnez dans la liste déroulante MOC (droite)',
  'LOCATION': 'EMPLACEMENT',
  'LimitAccessToAIOwner': 'Limiter l\'accès au propriétaire de l\'IA',
  'LimitAccessToAIOwnerInstruction': 'Si cochée: n\'autorise pas le propriétaire/responsable de l\'élément d\'action à modifier la description de l\'IA, la date d\'échéance ou à supprimer l\'IA.',
  'AllowTeamLeadToAttach': 'Autoriser le chef d\'équipe à joindre et modifier l\'IA',
  'AllowTeamLeadToAttachInstruction': 'Si cochée: pour les chefs après approbation en attente, peut uniquement joindre des fichiers, assigner, modifier le statut et commenter',
  'Links': 'Liens ',
  'List': 'Liste',
  'Load': 'Charger',
  'LoadImages': 'Charger les images',
  'LoadNewQAQC': 'Charger les nouveaux éléments QA QC',
  'Loading': 'Chargement',
  'LocaldbID': 'ID de base de données locale',
  'Location': 'Emplacement',
  'LogScreen': 'Écran de journal',
  'Login': 'Se connecter',
  'LoginExpiresOn': 'La connexion expire le',
  'LoginProfile': 'Profil de connexion',
  'Logout': 'Se déconnecter',
  'LookupbyPasscode': 'Recherche par code d\'accès',
  'Loose': 'En vrac',
  'MOC': 'MOC',
  'MOCWO': 'MOC ou WO#',
  'MOCWOProjectNumberRestrictionEnabled': 'Restriction de numéro de projet MOCWO activée',
  'Manage': 'Gérer',
  'ManageContentof': 'Gérer le contenu de',
  'ManagesEquipments': 'Gère les équipements',
  'Mandatory': 'Obligatoire',
  'Manufacturer': 'Fabricant - Modèle',
  'ManufacturerModel': 'Fabricant - Modèle',
  'ManufacturerModelfor': 'Fabricant - Modèle pour',
  'MarkasClosed': 'Marquer comme fermé',
  'Message': 'Message',
  'Milestone': 'Jalon QAQC',
  'MilestoneAndWorkOrders': 'Jalons/Ordres de travail QAQC',
  'MilestoneWorkOrder': 'OT de jalon QAQC',
  'MilestoneWorkOrders': 'Ordres de travail de jalon QAQC',
  'Milestones': 'Jalons QAQC',
  'MilestonesWorkOrdersNoavailable': 'Aucun OT de jalon disponible depuis QAQC',
  'MobileAppVersions': 'Versions de l\'application mobile',
  'MobileFeature': 'Fonctionnalité uniquement disponible sur mobile',
  'MobilePSSR': 'PSSR mobile',
  'Model': 'Modèle',
  'Multiple': 'Multiple',
  'MultipleFinalApprovers': 'Si cochée, permet au PSSR d\'avoir plusieurs approbateurs finaux',
  'Mustbecompletedbeforetostartup': 'L\'élément doit être complété avant le démarrage',
  'NA': 'N/A',
  'Name': 'Nom',
  'NewNonChevron': 'Nouveau non-Chevron',
  'NewOrganization': 'Nouvelle organisation',
  'NewPSSR': 'Nouveau PSSR',
  'NewPSSRCCC': 'Nouveau PSSR / CCC',
  'NewPSSRCCCORR': 'Nouveau PSSR / CCC / ORR ',
  'NewPSSRORR': 'Nouveau PSSR / ORR',
  'NewSectionDescription': 'Description de la nouvelle section',
  'No': 'Non',
  'Nomobileappversionsyet': 'Pas encore de versions d\'application mobile',
  'NoActionItems': 'Aucun élément d\'action',
  'Nofeedbackyet': 'Pas encore de retour',
  'Nomilestones': 'Aucun jalon/ordre de travail disponible depuis QAQC',
  'NonMOC': 'Non MOC',
  'NotRegistered': 'Non enregistré',
  'NotVisibleMobile': 'Cette section n\'est pas encore visible sur mobile jusqu\'à ce que l\'utilisateur synchronise',
  'Notauthorized': 'Non autorisé',
  'Note': 'Note',
  'Notfound': 'Non trouvé',
  'Notifications': 'Notifications',
  'OPEN': 'OUVERT',
  'OPSignature': 'Signature OP',
  'ORR': 'ORR',
  'OnHold': 'En attente',
  'OnlyFinalApprovercanApprovePSSR': 'Seul l\'approbateur final peut approuver le {{PssrTitle}}',
  'OnlyPSSRTeamLeadClosePSSR': 'Seul le chef d\'équipe de {{PssrTitle}} peut fermer le PSSR.',
  'OnlyPSSRTeamLeadcanClosePSSR': 'Seuls le chef d\'équipe PSSR et l\'approbateur final peuvent fermer le PSSR',
  'OnlyPSSRTeamLeadcanInitiatePSSR': 'Seul le chef d\'équipe de {{PssrTitle}} peut initier le PSSR',
  'OnlyPSSRTeamLeadcanSubmitforPendingApproval': 'Seul le chef d\'équipe de {{PssrTitle}} peut soumettre pour approbation en attente.',
  'OnlyTeamLeadorSectionLeadcananswerthequestions': 'Seul le chef d\'équipe ou le chef de section peut répondre aux questions.',
  'Open': 'Ouvert',
  'OpenStatus': 'Ouvert',
  'OpenError': 'Erreur d\'ouverture de fichier',
  'OpenErrorMsg': 'Il n\'a pas été possible d\'ouvrir le document',
  'OpeningDialog': 'Ouverture de la boîte de dialogue',
  'OpeningImage': 'Ouverture de l\'image...',
  'OperationTeam': 'Équipe d\'opération',
  'OperationsRepresentative': 'Représentant des opérations',
  'Optional': 'Optionnel',
  'OrgLabel': 'Étiquette d\'organisation',
  'Organization': 'Organisation',
  'OrganizationAdmin': 'Administrateur d\'organisation',
  'OrganizationLabel': 'Étiquette d\'organisation',
  'Organizationisrequired': 'L\'organisation est requise',
  'Other': 'Autre',
  'OtherOptions': 'Autres options',
  'OutstandingQuestions': 'Questions en suspens',
  'P3ActionItemsMustBeClosed': 'Les éléments d\'action {{P3Label}} doivent être fermés.',
  'SendAITypesToMOC': 'Envoyer les types d\'éléments d\'action à MOC',
  'P3Label': 'Étiquette P3',
  'P4ActionItemsMustBeClosed': 'Les éléments d\'action {{P4Label}} doivent être fermés.',
  'P4Label': 'Étiquette P4',
  'P5Label': 'Étiquette P5',
  'PARTICIPANTS': 'PARTICIPANTS',
  'PDFPreview': 'Aperçu PDF',
  'PIDVerificationRedLining': 'Vérification P&ID (Marquage rouge)',
  'PIDVerificationYellowLining': 'Vérification P&ID (Marquage jaune)',
  'PROJECTSPECIFICABCHECKLISTS': 'LISTES DE CONTRÔLE AB SPÉCIFIQUES AU PROJET',
  'PROJECTSTATUS': 'STATUT DU PROJET',
  'PSSR': 'PSSR',
  'PSSRID': 'ID PSSR',
  'PSSRCCC': 'PSSR / CCC',
  'PSSRInitiatorGroup': 'Groupe initiateur PSSR',
  'PSSRLabel': 'Étiquette PSSR',
  'PSSRMembers': 'Membres de {{PssrTitle}}',
  'PSSRORR': 'PSSR / ORR',
  'PSSRSections': 'Sections PSSR',
  'PSSRStatus': 'Statut de {{PssrTitle}}',
  'PSSRTeam': 'Équipe de {{PssrTitle}}',
  'PSSRTeamLead': 'Chef d\'équipe de {{PssrTitle}}',
  'PSSRTemplates': 'Modèles PSSR',
  'PSSRTemplateisrequired': 'Le modèle PSSR est requis',
  'PSSRTitle': 'Titre PSSR',
  'PSSRType': 'Type PSSR',
  'PSSRTypes': 'Types PSSR',
  'PSSRmusthaveaFinalApprovertocompleteWalkthrough': '{{PssrTitle}} doit avoir un approbateur final pour compléter la visite',
  'PSSRs': 'PSSRs',
  'NavigateToMainPage': '{{PssrTitle}}s',
  'Page': 'Page',
  'Search': 'Rechercher',
  'Participants': 'Participants',
  'ParticipantsinBlueparticipatedinWalkdown': 'Les participants en bleu ont participé à la visite',
  'ParticipatedinWalkdown': 'A participé à la visite',
  'PendingApproval': 'Approbation en attente',
  'PendingApprovalSubmittedOn': 'Approbation en attente soumise le',
  'Photos': 'Photos',
  'PickError': 'Erreur de sélection de fichier',
  'PleaseNotify': 'Veuillez informer les participants de synchroniser leurs appareils mobiles avant de poursuivre leurs activités',
  'PleaseclickSave': 'Veuillez cliquer sur Enregistrer',
  'Pleasecorrectpageaddress': 'Veuillez corriger l\'adresse de la page ou contacter le support si vous pensez que cette URL est correcte',
  'Pleasefillupthefields': 'Veuillez remplir les champs',
  'Pleasefillupthefieldsthataremarkedrequired': 'Veuillez remplir les champs marqués comme requis',
  'PleasegotoSettings': 'Veuillez aller dans \'Paramètres - Notifications - PSSR Mobile\' pour autoriser les notifications',
  'Pleaseselectanyoption': 'Veuillez sélectionner une option qui s\'applique à la portée du changement et au modèle',
  'Pleaseselectanyoptionthatapplytothescopeofchangeandtemplate': 'Veuillez sélectionner une option qui s\'applique à la portée du changement et au modèle',
  'Post-WalkdownActionItems': 'Éléments d\'action post-visite',
  'PostWalkdown': 'Post-visite',
  'PreStartupSafetyReview': 'Revue de sécurité pré-démarrage',
  'Present': 'Présent',
  'PrimaryCategory': 'Catégorie primaire',
  'Print': 'Imprimer',
  'PrinttoPDF': 'Imprimer en PDF',
  'Priority': 'Priorité',
  'ProcessActivated': 'Processus activé',
  'Progress': 'Progression',
  'Project': 'Projet',
  'ProjectName': 'Nom du projet',
  'ProjectTeamWillComplete': 'L\'équipe du projet complètera après le démarrage',
  'Projects': 'Projets',
  'ProjectsList': 'Liste des projets',
  'Projectteamwillcompleteafterstartup': 'L\'élément sera complété après le démarrage',
  'ProvidedBy': 'Fourni par',
  'PullFromKMS': 'Extraire de KMS',
  'PushNotification': 'Notification push',
  'Question': 'Question',
  'RESET': 'RÉINITIALISER',
  'ReOpen': 'Rouvrir',
  'ReadyToStartUp': 'Prêt au démarrage',
  'ReceivePushNotification': 'Recevoir les notifications push',
  'Receivedfrom': 'Reçu de',
  'Recordwillbepermanentlyremovedcontinue': 'L\'enregistrement sera définitivement supprimé, continuer?<br/>',
  'RedirectURL': 'URL de redirection',
  'ReferenceImage': 'Image de référence',
  'Reject': 'Rejeter',
  'Rejectionreason': 'Motif de rejet',
  'ReleaseDate': 'Date de sortie',
  'Remove': 'Supprimer',
  'RemoveLocalData': 'Supprimer les données locales',
  'RemoveLog': 'Supprimer le journal',
  'RemoveParticipant': 'Supprimer le participant',
  'RemoveRedLining': 'Supprimer le marquage rouge',
  'RemoveSection': 'Supprimer la section',
  'RemoveSignature': 'Supprimer la signature',
  'RemoveYellowLining': 'Supprimer le marquage jaune',
  'RemovingWarning': '<i>Éléments d\'action</i>, <i>Commentaires</i> et <i>Images</i> seront <u>Supprimés</u> de cette question',
  'Reopen': 'Rouvrir',
  'RequestAccess': 'Demander l\'accès',
  'RequestTranslation': 'Demander une traduction',
  'RequestedBy': 'Demandé par',
  'RequestedOn': 'Demandé le',
  'Requestedby': 'Demandé par',
  'RequireActionItemDueDate': 'Exiger une date d\'échéance pour l\'élément d\'action',
  'RequireFinalApproverBeforeInitiation': 'Exiger un approbateur final avant l\'initiation',
  'RequiredField': 'Ce champ est requis.',
  'RequiresApprovalForAccess': 'Nécessite une approbation pour l\'accès',
  'RequiresShowProject': '*Nécessite que l\'option Afficher le projet soit activée.',
  'ResetABChecklistsforEntireProject': 'Réinitialiser les listes de contrôle AB pour l\'ensemble du projet',
  'ResetABChecklist': 'Réinitialiser la liste de contrôle AB',
  'ResetData': 'Réinitialiser les données',
  'ResetSession': 'Réinitialiser la session',
  'ResolutionImages': 'Images de résolution',
  'RestorePssr': 'Restaurer {{PssrTitle}}',
  'RestrictApproverSignatureOnLeadsDevice': 'Restreindre la signature de l\'approbateur sur l\'appareil du chef',
  'ReturnTeamLead': 'Retour au chef d\'équipe',
  'ReviewInProgress': 'Révision en cours',
  'Role': 'Rôle',
  'RolesChangeWarning': 'Les rôles et les changements seront reflétés après la synchronisation',
  'Russian': 'Russe',
  'RussianTranslationRequested': 'Traduction russe demandée',
  'SAVESIGNATURE': 'ENREGISTRER LA SIGNATURE',
  'Save': 'Enregistrer',
  'SaveChanges': 'Enregistrer les modifications',
  'SaveGoBack': 'Enregistrer et revenir',
  'SaveImage': 'Enregistrer l\'image',
  'SaveSignature': 'Enregistrer la signature',
  'SavingFile': 'Enregistrement du fichier',
  'SavingImage': 'Enregistrement de l\'image',
  'ScheduledEmail': 'Déclencher un email programmé (chaque lundi)',
  'Screen': 'Écran',
  'SearchMOCNumber': 'Rechercher un numéro MOC',
  'SecondaryCategory': 'Catégorie secondaire',
  'SectionType': 'Type de section',
  'SectionLead': 'Chef de section',
  'Sections': 'Sections',
  'ShowSectionsCollapsedInstruction': '*Si cochée, les sections PSSR seront affichées repliées lors de l\'édition',
  'Select': 'Sélectionner',
  'SelectFileError': 'Erreur de sélection de fichier',
  'SelectFromKMSMOCList': 'Sélectionner dans la liste MOC KMS',
  'SelectLead': 'Sélectionner un chef',
  'SelectOption': 'Sélectionner une option',
  'SelectParticipant': 'Sélectionner un participant',
  'SelectResponse': 'Sélectionner une réponse',
  'SelectaDrawing': 'Sélectionner un dessin',
  'SelectfromQAQC': 'Sélectionner depuis QAQC',
  'Selectpages': 'Sélectionner les pages',
  'Selectthepagestoconverttoimages': 'Sélectionner les pages à convertir en images',
  'Selectuserfor': 'Sélectionner un utilisateur pour',
  'SelectUser': 'Sélectionner un utilisateur',
  'Send': 'Envoyer',
  'SendAllNotificationsToApprovers': 'Les approbateurs reçoivent toutes les notifications PSSR',
  'SendEmailReminder': 'Envoyer un rappel par email',
  'SendMOCforStartup': 'Envoyer à l\'enregistrement MOC pour approbation de démarrage',
  'SerialNumber': 'Numéro de série',
  'SerialNumberRequired': 'Numéro de série requis',
  'Settings': 'Paramètres',
  'Shared': 'Partagé',
  'Shipment': 'Expédition',
  'ShouldAddCommentToQuestion': 'Exiger un commentaire pour la question N/A',
  'Show': 'Afficher',
  'ShowCCC': 'Afficher CCC',
  'ShowDeletedPSSR': 'Afficher les {{PssrTitle}} supprimés',
  'ShowKMS': 'Afficher KMS',
  'ShowORR': 'Afficher ORR',
  'ShowP5': 'Afficher P5',
  'ShowProject': 'Afficher le projet',
  'ShowProjectInput': 'Afficher l\'entrée du projet',
  'ShowProjectInputAsDropdown': 'Afficher l\'entrée du projet comme liste déroulante',
  'ShowPssrType': 'Afficher le type PSSR',
  'ShowQAQC': 'Afficher QAQC',
  'ShowSectionsCollapsed': 'Afficher les sections repliées',
  'ShowVerbalApproval': 'Afficher l\'approbation verbale',
  'SignatoryName': 'Nom du signataire',
  'Signature': 'Signature',
  'SignatureCapture': 'Capture de signature',
  'Signatures': 'Signatures',
  'SignedBy': 'Signé par',
  'SignedOnBehalfOf': 'Signé au nom de',
  'Skidded': 'Sur patins',
  'SortBy': 'Trier par',
  'SortChangesApplied': 'Les changements de tri seront appliqués après avoir appuyé sur le bouton Enregistrer',
  'SortOrder': 'Ordre de tri EAM',
  'Startaddingparticipants': 'Commencer à ajouter des participants',
  'Started': 'Commencé',
  'Status': 'Statut',
  'StatusIsRequired': 'Le statut est requis',
  'SubArea': 'Sous-zone',
  'SubCategories': 'Sous-catégories',
  'SubSection': 'Sous-section',
  'Subcategories': 'Sous-catégories',
  'Submit': 'Soumettre',
  'SubmitforApproval': 'Soumettre pour approbation',
  'Submitforapproval': 'Soumettre pour approbation',
  'SubsectionDescription': 'Description de sous-section',
  'Summary': 'Résumé',
  'SummarySignature': 'Signature du résumé',
  'Sync': 'Synchroniser',
  'SystemAdministrators': 'Administrateurs système',
  'TEAMMEMBERS': 'MEMBRES DE L\'ÉQUIPE',
  'Tag': 'Étiquette',
  'TagCode': 'Code d\'étiquette',
  'TagNo': 'N° d\'étiquette',
  'Takeaphoto': 'Prendre une photo',
  'Tank': 'Réservoir',
  'TaskPlanSections': 'Sections du plan de tâches',
  'TaskPlan': 'Plan de tâches',
  'TaskPlanNoteHeader': '[Note]&nbsp;Le nom de code doit être unique et ne peut pas être renommé après la création du plan de tâches',
  'TeamLead': 'Chef d\'équipe',
  'Template': 'Modèle',
  'Test': 'Test',
  'TestforDeleteDBwithoutApprover': 'Test de suppression de base de données sans approbateur',
  'TheTaskPlanfieldisrequired': 'Le champ Plan de tâches est requis',
  'Thereareexistingitemsusingit': 'Il existe des éléments qui l\'utilisent',
  'Therewasanerrorprocessingtryagain': 'Une erreur s\'est produite lors du traitement de votre demande. Veuillez réessayer plus tard ou contacter le service d\'assistance.',
  'Thisfieldisrequired': 'Ce champ est requis.',
  'Thisisnotareversiblechange': 'Ce changement n\'est pas réversible',
  'TimeCaptured': 'Heure capturée',
  'Title': 'Titre',
  'Titleisrequired': 'Le titre est requis',
  'TotalQuestions': 'Total des questions',
  'TranslationCompleted': 'Traduction terminée',
  'TranslationHistory': 'Historique de traduction',
  'TranslationInProgress': 'Traduction en cours',
  'TranslationRequested': 'Traduction demandée',
  'Translator': 'Traducteur',
  'Type': 'Type',
  'TypeOtherisonlyfornon': 'Le type "Autre" est uniquement destiné aux utilisateurs non-Chevron, l\'utilisation de ce type peut entraîner des données utilisateur en double',
  'Undo': 'Annuler',
  'UndoImageError': 'Erreur d\'annulation d\'image',
  'Unit': 'Unité',
  'Update': 'Mettre à jour',
  'UpdatedBy': 'Mis à jour par',
  'UpdatedByUpdatedDate': 'Mis à jour par/Date de mise à jour',
  'UpdatedDate': 'Date de mise à jour',
  'Upload': 'Télécharger',
  'UploadDocError': 'Erreur de téléchargement de document',
  'UploadDocErrorMsg': 'Il n\'a pas été possible d\'enregistrer le document',
  'UploadDocument': 'Télécharger un document',
  'UploadDocuments': 'Télécharger des documents',
  'UploadImages': 'Télécharger des images',
  'UploadMsg': 'Le nouveau document a été enregistré',
  'Uploadaphoto': 'Télécharger une photo',
  'User': 'Utilisateur',
  'User1': 'Utilisateur 1',
  'User2': 'Utilisateur 2',
  'User3': 'Utilisateur 3',
  'User4': 'Utilisateur 4',
  'UserAlreadyAdded': 'Utilisateur déjà ajouté',
  'UserType': 'Type d\'utilisateur',
  'Users': 'Utilisateurs',
  'Usersavedsuccessfully': 'Utilisateur enregistré avec succès',
  'Vendor': 'Fournisseur',
  'VerbalApproval': 'Approbation verbale',
  'VerbalApprovalReceivedBy': 'Approbation verbale reçue par',
  'VerbalApprovalforStartupOn': 'Approbation verbale pour démarrage le',
  'Version': 'Version',
  'ViewImage': 'Voir l\'image',
  'ViewItems': 'Voir les éléments',
  'WO': 'OT',
  'WTNotPresentParticipantsWarning': 'Les participants suivants n\'ont pas été marqués comme présents',
  'WTParticipantsWithoutSignatureWarning': 'Les participants suivants n\'ont pas de signature',
  'WTRestrictParticipantsModificationWarning': 'Après avoir terminé la visite, les participants ne pourront plus être modifiés',
  'Walkdown': 'Visite',
  'WalkdownSignature': 'Signature de visite',
  'WalkdownComplete': 'Visite terminée',
  'WalkdownCompletedOn': 'Visite terminée le',
  'Warning': 'Avertissement',
  'WebLink': 'Lien web',
  'WorkOrder': 'Ordre de travail QAQC',
  'WorkOrders': 'Ordres de travail QAQC',
  'WorkOrdersNoavailable': 'Pas de jalons/ordres de travail disponibles depuis QAQC',
  'XCoordinate': 'Coordonnée X',
  'YCoordinate': 'Coordonnée Y',
  'Yes': 'Oui',
  'Youareabouttologout': 'Vous êtes sur le point de vous déconnecter, cela supprimera les données locales sur cet appareil, voulez-vous continuer?',
  'Youareabouttorequestaccessfor': 'Vous êtes sur le point de demander l\'accès pour <strong>{{Name}}</strong>, voulez-vous continuer?',
  'Youareloggedinas': 'Vous êtes connecté en tant que ',
  'Youdonothaveaccesstothispage': 'Vous n\'avez pas accès à cette page',
  'Yourprofile': 'Votre profil',
  'approvethisPSSRreadyforstartup': 'approuver ce PSSR prêt pour le démarrage',
  'cannotberemoved': 'ne peut pas être supprimé',
  'cost255': 'Code de coût (max 255 caractères)',
  'desc5000': 'Ajoutez la description ici (max 5000 caractères)',
  'description1920': 'Ajoutez la description ici (max 1920 caractères)',
  'description500': 'Ajoutez la description ici (max 500 caractères)',
  'device150': 'Nom du type d\'appareil (max 150 caractères)',
  'donothaveaccesstothePSSRapplication': 'n\'ont pas accès à l\'application PSSR',
  'eam50': 'Type EAM (max 50 caractères)',
  'eamclass80': 'Classe EAM (max 80 caractères)',
  'eamcritical50': 'Criticité EAM (max 50 caractères)',
  'eamdep255': 'Département EAM (max 255 caractères)',
  'eamdesc80': 'Description EAM (max 80 caractères)',
  'eamname80': 'Nom EAM (max 80 caractères)',
  'fromTaskPlan': 'du plan de tâches',
  'fromTaskPlanSection': 'de la section du plan de tâches',
  'group155': 'Nom du groupe (max 155 caractères)',
  'isrequired': 'est requis',
  'list': 'liste',
  'manufacturer250': 'Nom du fabricant (max 250 caractères)',
  'model250': 'Modèle (max 250 caractères)',
  'noticetousers': 'Avis aux utilisateurs',
  'of10': 'sur 10',
  'of150': 'sur 150',
  'of155': 'sur 155',
  'of250': 'sur 250',
  'of255': 'sur 255',
  'of50': 'sur 50',
  'of500': 'sur 500',
  'of80': 'sur 80',
  'optional': 'optionnel',
  'select1milestone': 'Veuillez sélectionner 1 jalon pour voir les ordres de travail dans ce jalon',
  'tagcode10': 'Code d\'étiquette (max 10 caractères)',
  'tagno10': 'N° d\'étiquette (max 10 caractères)',
  'typeemail': 'saisir l\'email du nouvel utilisateur...',
  'typelastname': 'saisir le nom de famille du nouvel utilisateur...',
  'typenewuser': 'saisir le nom du nouvel utilisateur...',
  'typeuseremailname': 'saisir le nom ou l\'email de l\'utilisateur chevron...',
  'willberemoved': 'sera supprimé',
  'willbeungrouped': 'Si des équipements sont rattachés à ce groupe, ils seront dégroupés',
  'x255': 'Coordonnée X (max 255 caractères)',
  'y255': 'Coordonnée Y (max 255 caractères)',
  'yourAccessRequestisinProgress': 'votre demande d\'accès est en cours',
  'youwanttoproceed': 'voulez-vous continuer',
  'Unabletocompleteoperation': 'Impossible de terminer l\'opération',
  'SaveCompleted': 'Enregistrement terminé',
  'Itemhasbeenaddedsuccessfully': 'L\'élément a été ajouté avec succès',
  'ShowProjectInputInstruction': '*Affiche la liste déroulante/entrée du projet',
  'ShowQAQCInstruction': '*Active le module QAQC au niveau du module de projet. Nécessite que l\'option Afficher le projet soit activée d\'abord.',
  'ShowKMSInstruction': '*Affiche le bouton "Extraire de KMS" lorsque vous créez un nouveau PSSR',
  'AllowWetSignatureInstruction': '*Permet au représentant des opérations d\'approuver le PSSR au statut "Approbation en attente". Affiche le bouton "Approuver par signature manuscrite"',
  'ShowVerbalApprovalInstruction': '*Affiche une entrée dans l\'application mobile pour indiquer manuellement qui approuve. Cela ne provoque aucune action. Peut être effectué par le chef ou l\'approbateur',
  'ScheduledEmailInstruction': '*Chaque lundi à 8h00 CST, un email est déclenché pour tous les utilisateurs ayant des éléments d\'action en attente',
  'ShowCCCInstruction': '*Affiche "CCC" dans certains en-têtes/titres/étiquettes (Certificat de fin de construction)',
  'ShowORRInstruction': '*Affiche "ORR" dans certains en-têtes/titres/étiquettes (Revue de préparation opérationnelle)',
  'ShowPssrTypeInstruction': '*Affiche la liste déroulante "Types PSSR" (ci-dessous)',
  'AllowNAResponsesInstruction': '*Si désactivé: une question au PSSR qui est répondue par N/A nécessiterait un commentaire ou un élément d\'action pour être considérée comme complétée.',
  'PssrInstructionsInstruction': '*Affiche les instructions générales pour le PSSR',
  'AllowLeadsDeleteQuestionsInstruction': '*Permet aux chefs de supprimer des questions pour un PSSR au statut Brouillon ou Initié.',
  'EnableAllowMembersCompletePSSRInstruction': '*Si cochée, permet à tout membre de l\'équipe de répondre aux questions, signer des questions et créer des éléments d\'action jusqu\'à ce que le PSSR soit approuvé',
  'MOCWOProjectNumberRestrictionEnabledInstruction': '*Si activé: MOC et OT sont requis pour créer un PSSR',
  'AllowMultiApproverInstruction': '*Si activé: Le PSSR peut avoir plus d\'un approbateur',
  'RestrictApproverSignatureOnLeadsDeviceInstruction': '*Si activé: Le chef PSSR ne peut pas signer au nom de l\'approbateur dans l\'application mobile',
  'AllowLeadtoShareDeviceWithApprover': 'Autoriser le chef à partager l\'appareil avec l\'approbateur',
  'AllowLeadtoShareDeviceWithApproverInstruction': '*Si activé: Le chef peut partager l\'appareil avec l\'approbateur si l\'approbateur est présent pour signer.',
  'RequiresApprovalForAccessInstruction': '*Si ce flag est activé, l\'utilisateur devra attendre que l\'administrateur BU lui accorde l\'accès. Si désactivé, l\'utilisateur aura un accès instantané en sélectionnant cette BU',
  'AllowApproverToSubmitForApprovalInstruction': '*Si cochée, l\'approbateur final pourra voir le bouton Soumettre pour approbation dans le PSSR',
  'OrganizationCannotBeEmpty': '{{OrganizationLabel}} ne peut pas être vide',
  'OrganizationSuccessfullyAdded': '{{OrganizationLabel}} ajouté avec succès',
  'MOCImportedSuccessfully': 'MOC importé avec succès',
  'GeneralInformationSavedSuccessfully': 'Informations générales enregistrées avec succès',
  'Therecordenteredalreadyexists': 'L\'enregistrement saisi existe déjà',
  'SelectuserforTranslationRole': 'Sélectionner un utilisateur pour le rôle de traduction',
  'TranslatetoLanguage': 'Traduire vers la langue',
  'Selecttranslator': 'Sélectionner un traducteur',
  'PresentParticipantsInstruction': 'Les participants en <span class="box participated">&nbsp;bleu&nbsp;</span> ont participé à la visite',
  'PssrParticipantAddedSuccessMessage': 'Utilisateur ajouté aux participants du PSSR avec succès',
  'RoleAlreadyAddedWarningMessage': 'Le rôle {{RoleLabel}} est déjà ajouté',
  'MaxParticipantsPerBatchInstruction': 'Seuls 5 utilisateurs peuvent être ajoutés à la fois',
  'MaxParticipantsPerBatchWarningMessage': 'Limite de {{maxParticipantsLimit}} utilisateurs atteinte, veuillez sélectionner ajouter',
  'ParticipantAlreadyParticipatedWarningMessage': 'Cet utilisateur est déjà membre de ce PSSR',
  'ManageSectionUsersSyncWarning': 'Cette section n\'est pas encore visible sur mobile jusqu\'à ce que l\'utilisateur synchronise. Veuillez informer les participants de synchroniser leurs appareils mobiles avant de poursuivre leurs activités.',
  'NotFoundComponentTitle': 'Non trouvé',
  'NotFoundComponentDescription': 'Veuillez corriger l\'adresse de la page ou contacter le support si vous pensez que cette URL est correcte',
  'UnauthorizedTitle': 'Non autorisé',
  'UnauthorizedDescription': 'Vous n\'avez pas accès à cette page.',
  'BUisrequired': 'La BU est requise',
  'SectionLeadWasAlreadyAddedWarningMessage': '{{UserName}} est déjà chef de cette section',
  'SectionLeadAddedErrorMessage': 'Une erreur s\'est produite lors de l\'ajout de l\'utilisateur',
  'SectionLeadRemovedErrorMessage': 'Une erreur s\'est produite lors de la suppression de l\'utilisateur',
  'AddResponseErrorMessage': 'Une erreur s\'est produite lors de la création de la question de réponse',
  'ConfirmRemoveSectionTitle': 'Supprimer la section',
  'ConfirmRemoveSectionDescription': 'Êtes-vous sûr de vouloir effectuer cette action?',
  'MilestoneWorkOrdersWarningMessage': 'Veuillez sélectionner 1 jalon pour voir les ordres de travail dans ce jalon',
  'QAQCAddSectionLeadToPssr': 'Assigner des chefs de section',
  'LoadBusinessUnitsErrorMessage': 'Erreur lors de l\'obtention des unités d\'affaires',
  'LoadOrganizationsErrorMessage': 'Erreur lors de l\'obtention des organisations',
  'AddProjectErrorMessage': 'Erreur lors de l\'ajout du nouveau {{EventLabel}}',
  'AddProjectSuccessMessage': 'Projet ajouté avec succès',
  'LoadQAQCErrorMessage': 'Erreur lors de l\'obtention de {{EventLabel}} depuis QAQC',
  'SaveQAQCAlreadyExistsWarningMessage': '{{EventLabel}} existe déjà',
  'SaveQAQCSuccessMessage': '{{EventLabel}} ajouté avec succès',
  'CompletedTotalPSSRs': 'PSSRs complétés/Totaux',
  'ProjectUpdatedSucessfully': 'Projet mis à jour avec succès',
  'ConfirmDeleteProjectTitle': 'Confirmer la suppression du projet',
  'ConfirmDeleteProjectWithPssrsDescription': 'L\'action suivante pourrait supprimer le projet et les PSSR impliqués. Souhaitez-vous continuer?',
  'ConfirmDeleteProjectWithoutPssrsDescription': 'Souhaitez-vous continuer?',
  'ConfirmInitiateProjectPssrsTitle': 'Voulez-vous initier tous les PSSR?',
  'ConfirmInitiateProjectPssrsDescription': 'Voulez-vous initier tous les PSSR?',
  'UnableLoadQAQCMilestonesMessage': 'Impossible d\'accéder au système QAQC pour les jalons, veuillez réessayer plus tard',
  'UnableLoadQAQCWorkOrdersMessage': 'Impossible d\'accéder au système QAQC pour les ordres de travail, veuillez réessayer plus tard',
  'LoadProjectDetailsErrorMessage': 'Erreur lors du chargement des détails du projet',
  'QAQCItemsAreUpToDateMessage': 'Les éléments QAQC sont à jour',
  'QAQCNewItemInputWarning': 'Veuillez sélectionner un élément de la liste {{qaqcLabel}} et sélectionner les valeurs de hiérarchie et/ou le modèle',
  'ConfirmCloseProjectTitle': 'Fermer le projet',
  'ConfirmCloseProjectDescription': 'Voulez-vous fermer ce projet?',
  'DownloadActionItemsExcelReportFailureMessage': 'Échec du téléchargement du fichier Excel',
  'ConfirmDeleteAreaTitle': 'Êtes-vous sûr de vouloir supprimer {{hierarchyLabel1}}',
  'ConfirmActivateAreaTitle': 'Êtes-vous sûr de vouloir activer {{hierarchyLabel1}}',
  'ConfirmActivateAreaDescription': 'Tous les {{ hierarchyLabel2 }} & {{ hierarchyLabel3 }} associés seront activés.',
  'ConfirmDeleteAreaDescription': 'Tous les {{ hierarchyLabel2 }} & {{ hierarchyLabel3 }} associés seront supprimés.',
  'ConfirmDeleteSubAreaTitle': 'Êtes-vous sûr de vouloir supprimer {{ hierarchyLabel2 }}',
  'ConfirmDeleteSubAreaDescription': 'Tous les {{ hierarchyLabel3 }} associés seront supprimés',
  'ConfirmActivateSubAreaTitle': 'Êtes-vous sûr de vouloir activer {{ hierarchyLabel2 }}',
  'ConfirmActivateSubAreaDescription': 'Tous les {{ hierarchyLabel3 }} associés seront activés',
  'ConfirmActivateFacility': 'Êtes-vous sûr de vouloir activer',
  'NewGroupadded': 'Nouveau groupe ajouté',
  'RequiredFields': 'Champs obligatoires',
  'AddedUserSuccessfulMessage': 'Utilisateur ajouté avec succès',
  'DeletedUserSuccessfulMessage': 'Utilisateur supprimé avec succès',
  'EditedGroupSucessfulMessage': 'Groupe mis à jour avec succès',
  'Userisrequired': 'L\'utilisateur est requis',
  'FirstNameisrequired': 'Le prénom est requis',
  'SharedUserNameisrequired': 'Le nom d\'utilisateur partagé est requis',
  'Emailisrequired': 'L\'email est requis',
  'User1isrequired': 'L\'utilisateur 1 est requis',
  'Usertypeiswrong': 'Le type d\'utilisateur est incorrect',
  'RepeatedEmailsInputWarning': 'Ces emails sont répétés: [{{repeatedEmails}}}]<br/>',
  'Shareduserfound': 'Utilisateur partagé trouvé',
  'AddRemoveSubcategory': 'Ajouter/Supprimer sous-catégorie',
  'CreateNewCategory': 'Créer nouvelle catégorie',
  'IsActive': 'Est actif',
  'EditCategory': 'Modifier la catégorie',
  'CommentisRequired': 'Le commentaire est requis<br>',
  'RejectreasonisRequired': 'Le motif de rejet est requis<br>',
  'Duedateisrequired': 'La date d\'échéance est requise',
  'IAgree': 'Je suis d\'accord',
  'All': 'Tout',
  'CreateFeedback': 'Créer un retour',
  'Enhancement': 'Amélioration',
  'Environment': 'Environnement',
  'Web': 'Web',
  'MobileWeb': 'Mobile & Web',
  'Mobile': 'Mobile',
  'High': 'Élevé',
  'Medium': 'Moyen',
  'Low': 'Faible',
  'FeedbackSuccessfullyadded': 'Retour ajouté avec succès',
  'EditFeedback': 'Modifier le retour',
  'Typetoaddanewdiscussioncomment': 'Tapez pour ajouter un nouveau commentaire de discussion',
  'Attachments': 'Pièces jointes',
  'FeedbackUpdated': 'Retour mis à jour',
  'UpdatedFeedbacksAttachmentErrorMessage': 'Une erreur s\'est produite avec les fichiers. Veuillez vérifier que vos fichiers ne sont pas corrompus ou trop volumineux',
  'LoadingKMSItemsErrorMessage': 'Une erreur s\'est produite lors de la recherche d\'éléments KMS',
  'TaskPlanManageTitle': 'Gérer le contenu de {{ Description }}',
  'CreateNewSection': 'Créer une nouvelle section',
  'NewSubsection': 'Nouvelle sous-section',
  'ItemType': 'Type d\'élément',
  'ConfirmDeleteTaskPlanSectionMessage': 'Êtes-vous sûr de vouloir supprimer\n    <span style="color: red">{{ taskPlanSectionDesc }}</span> <br />\n    du plan de tâches {{ taskPlanDesc }} ?',
  'ConfirmDeleteTaskPlanSubSectionMessage': 'Êtes-vous sûr de vouloir supprimer <span style="color:red">{{subSection}}</span> <br> de la section de plan de tâches <b>{{section}}</b> ?',
  'EditTaskPlanSubSection': 'Modifier la sous-section du plan de tâches',
  'RequestforComments': 'Demande de commentaires',
  'RequestforActionItems': 'Demande d\'éléments d\'action',
  'PSSRInitializedSuccessfully': 'PSSR initialisé avec succès',
  'PrimeNgCalendarLabels': {
    'firstDayOfWeek': 0,
    'dayNames': [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi'
    ],
    'dayNamesShort': [
      'Dim',
      'Lun',
      'Mar',
      'Mer',
      'Jeu',
      'Ven',
      'Sam'
    ],
    'dayNamesMin': [
      'Di',
      'Lu',
      'Ma',
      'Me',
      'Je',
      'Ve',
      'Sa'
    ],
    'monthNames': [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre'
    ],
    'monthNamesShort': [
      'Jan',
      'Fév',
      'Mar',
      'Avr',
      'Mai',
      'Jun',
      'Jul',
      'Aoû',
      'Sep',
      'Oct',
      'Nov',
      'Déc'
    ],
    'today': 'Aujourd\'hui',
    'clear': 'Effacer',
    'dateFormat': 'dd/mm/yy',
    'weekHeader': 'Sem'
  },
  'Adminmenu': 'Menu admin',
  'Organizations': 'Organisations',
  'UserGuide': 'Guide utilisateur',
  'Administration': 'Administration',
  'ProjectSpecific': 'Spécifique au projet',
  'Showdeletedprojects': 'Afficher les projets supprimés',
  'ProjectManagers': 'Gestionnaires de projet',
  'ProjectTeamMembers': 'Membres de l\'équipe projet',
  'Activate': 'Activer',
  'AddActionItem': 'Ajouter un élément d\'action',
  'Attention': 'Attention',
  'BacktoCategoryList': 'Retour à la liste des catégories',
  'Category': 'Catégorie',
  'CompleteTranslationWarning': 'Veuillez traduire le titre PSSR, la description, le titre de l\'élément d\'action et les commentaires de l\'élément d\'action',
  'ConfirmTranslationRequest': 'Vous êtes sur le point de demander une traduction en {{language}} à {{email}}',
  'DeselectAll': 'Tout désélectionner',
  'FirstName': 'Prénom',
  'Itemsselected': 'Éléments sélectionnés',
  'Language': 'Langue',
  'LastName': 'Nom de famille',
  'MOC#': 'MOC #',
  'New': 'Nouveau',
  'Org': 'Org',
  'ShowDeletedPSSRCCC': 'Afficher les PSSR / CCC supprimés',
  'ShowDeletedPSSRCCCORR': 'Afficher les PSSR / CCC / ORR supprimés',
  'ShowDeletedPSSRORR': 'Afficher les PSSR / ORR supprimés',
  'Togglenavigation': 'Basculer la navigation',
  'Youshouldnothaveemptysections': 'Vous ne devriez pas avoir de sections vides',
  'togglesearch': 'basculer la recherche',
  'GenericErrorTitle': 'Erreur interne',
  'GenericErrorDescription': 'Une erreur s\'est produite lors du traitement de votre demande. Veuillez réessayer plus tard ou contacter le service d\'assistance.',
  'Kazakh': 'Kazakh',
  'PSSRmusthaveaFinalApprovertocompleteWalkdown': 'Le PSSR doit avoir un approbateur final pour compléter la visite',
  'ParticipatedinWalkthrough': 'A participé à la visite',
  'Subsection': 'Sous-section',
  'AccessUntilApprove': 'Accès jusqu\'à approbation',
  'AllNotifications': 'Toutes les notifications',
  'AreyousureyouwanttoSubCategory': 'Êtes-vous sûr de vouloir sous-catégoriser',
  'DueDateMandatory': 'Date d\'échéance obligatoire',
  'FinalApproverSubmit': 'Soumission par l\'approbateur final',
  'FinalApproverInitiate': 'Initiation par l\'approbateur final',
  'SectionsCollapsed': 'Sections réduites',
  'Portuguese': 'Portugais',
  'Dutch': 'Néerlandais',
  'SysAdmin': 'Admin système',
  'ChevronDisclaimer': 'Ce produit logiciel Chevron est destiné uniquement aux utilisateurs autorisés. Dans la mesure permise par la loi, en\n  utilisant ce produit logiciel, vous reconnaissez et consentez à la surveillance, l\'accès (y compris le\n  déchiffrement et l\'inspection du trafic Internet chiffré sélectionné),\n  l\'utilisation ou la divulgation par Chevron de toute information générée, reçue ou stockée sur ce\n  système/appareil et renoncez à tout droit ou attente de confidentialité liée à votre utilisation. L\'utilisation non autorisée\n  et/ou inappropriée de ce logiciel\n  en violation des politiques d\'entreprise de Chevron ne sera pas tolérée et pourrait entraîner des mesures disciplinaires,\n  y compris le licenciement.',
  'ConfirmDeletePSSRTitle': 'Confirmer la suppression',
  'ConfirmDeletePSSRMessage': 'Le PSSR sera définitivement supprimé, continuer?<br/>',
  'ConfirmNewTrainingTitle': 'Confirmer la nouvelle formation PSSR',
  'ConfirmNewTrainingMessage': 'De nouveaux PSSR de formation seront créés.<br/> Voulez-vous continuer?<br/>',
  'ConfirmDeleteActionItemMessage': 'Êtes-vous sûr de vouloir effectuer cette action?',
  'CannotCloseProjectDueOpenPSSRs': 'Impossible de fermer le projet car il y a des PSSR ouverts',
  'PSSRIdisrequired': 'L\'ID PSSR est requis',
  'ImportFromisrequired': 'Importer depuis est requis.',
  'MOCIDisalreadypresentintheImportlist': 'L\'ID MOC est déjà présent dans la liste d\'importation.',
  'ErrorhappenedwhileimportingPSSR': 'Une erreur s\'est produite lors de l\'importation du PSSR',
  'RestoreProject': 'Restaurer le projet',
  'Spanish': 'Espagnol',
  'ImportPSSRs': 'Importer PSSRs',
  'Import': 'Importer',
  'Application': 'Application',
  'Records': 'Enregistrements',
  'Imported': 'Importé',
  'Errors': 'Erreurs',
  'ImportAll': 'Tout importer',
  'QAQCImport': 'Import QAQC',
  'Start': 'Démarrer PSSR',
  'ePSSRServiceNowTicketingInstructions': 'Instructions de billetterie ePSSR Service Now',
  'ePSSRBUSupportInformation': 'Informations de support de l\'unité commerciale',
  'SupportInfoNote': '*Ces informations seront affichées dans la page d\'assistance',
  'ReportanIssue': 'Signaler un problème',
  'EnhancementRequest': 'Demande d\'amélioration',
  'UserAccessRequest': 'Demande d\'accès utilisateur',
  'ApplicationSupportRequestForm': 'Accédez au <a href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank">Formulaire de demande de support d\'application</a> dans le portail de service informatique Chevron',
  'UndertheApplicationFieldselectMobilePSSR': 'Sous le champ Application, sélectionnez <b>Mobile PSSR</b>.',
  'ToreportanissueorbugpleaseselectReportanIssueTosubmitanenhancementrequestoruseraccessrequestpleaseselectServiceRequestHitNext': 'Pour signaler un problème ou un bug, veuillez sélectionner <b>Signaler un problème</b>. Pour soumettre une demande d\'amélioration ou d\'accès utilisateur, veuillez sélectionner <b>Demande de service</b>. Cliquez sur Suivant.',
  'FillouttheDescriptionoftheProblemImpactandUrgency': 'Remplissez la description du problème, de l\'impact et de l\'urgence.',
  'PressNextandthenSubmit': 'Appuyez sur Suivant puis sur Soumettre.',
  'TheePSSRSupportTeamwillacknowledgethereceiptoftheticketin24hoursduringbusinesshours': 'L\'équipe de support ePSSR accusera réception du ticket dans les 24 heures pendant les heures ouvrables.',
  'PleaseselectEnhancementsunderTypeofRequests': 'Veuillez sélectionner <b>Améliorations</b> sous Type de demandes.',
  'SelectPriorityLowModerateHigh': 'Sélectionnez la priorité <b>(Faible, Modérée, Élevée)</b>',
  'FillouttheDescriptionofRequest': 'Remplissez la description de la demande',
  'SelectNextandSubmit': 'Sélectionnez Suivant puis Soumettre.',
  'TheePSSRSupportTeamwillreviewenhancementrequestsaspartoftheSurfaceDigitalPIPlanningProcess': 'L\'équipe de support ePSSR examinera les demandes d\'amélioration dans le cadre du processus de planification PI Surface Digital',
  'PleaseselectRequestAccessunderTypeofRequests': 'Veuillez sélectionner <b>Demande d\'accès</b> sous Type de demandes.',
  'SelectAccessRequestTypeAddorRemove': 'Sélectionnez le type de demande d\'accès <b>(Ajouter ou Supprimer)</b>',
  'SpecifyRoleandAccesstheUserneeds': 'Spécifiez le rôle et l\'accès dont l\'utilisateur a besoin.',
  'UserAlreadyPartipatedInPssr': 'Le participant ["{{newTranslator}}"] a déjà participé au pssr',
  'TranslateActionItem': 'Traduire l\'élément d\'action',
  'AbandonedPSSRInterval': 'Intervalle PSSR en stagnation',
  'ShowOnlyDeletedPSSRs': 'Afficher uniquement les PSSR supprimés',
  'ShowOnlyAbandonedPSSRs': 'Afficher uniquement les PSSR en stagnation',
  'CloseConfirmation': 'N\'oubliez pas qu\'en fermant le PSSR, vous confirmez que tous les éléments d\'action ont été clôturés. Fermer le PSSR?',
  'ReimportAllSharedUsers': 'Réimporter tous les utilisateurs partagés',
  'ImportSharedUsersFailed': 'Échec de l\'importation',
  'ImportSharedUsersIncompleted': 'Importation incomplète',
  'ImportSharedUsersCompleted': 'Importation terminée en: {{ minutes }} mins',
  'ConfirmReimportAllSharedUsersHeader': 'Réimporter tous les utilisateurs partagés',
  'ConfirmReimportAllSharedUsersMessage': 'Vous êtes sur le point de mettre à jour la configuration de tous les utilisateurs partagés.<br> Cette opération pourrait prendre plusieurs minutes.',
  'SendaremindertoAssignees': 'Envoyer un rappel aux responsables',
  'SendReminderInstructions': 'Envoyer un rappel aux responsables pour tous les AIs ouverts.\nLorsque le PSSR est en statut d\'approbation en attente, \nles approbateurs recevront une notification.',
  'Sendamessage': 'Envoyer un message',
  'SendanemailmessagetoallPSSRParticipants': 'Envoyer un message électronique à tous les participants PSSR',
  'ImportSharedUserOptionWhitePagesTitle': 'Intégration Pages Blanches',
  'ImportSharedUserOptionWhitePagesDescription': 'Utilisez ce type d\'email partagé si vous avez besoin de synchroniser avec Pages Blanches. La liste des utilisateurs sera mise à jour automatiquement au fil du temps. Certains utilisateurs peuvent être automatiquement ajoutés ou supprimés de cet email partagé.',
  'ImportSharedUserOptionCustomTitle': 'Email partagé personnalisé',
  'ImportSharedUserOptionCustomDescription': 'Gérer manuellement la liste des utilisateurs.',
  'ImportActionItemsSuccessfully': 'Éléments d\'action importés avec succès',
  'ImportActionItemsNone': 'Aucun élément d\'action à importer',
  'French': 'Français',
  'Import.MOC.Create.PSSR': 'Importer MOC et Créer PSSR',
  'Import.MOC.Name': 'Nom de MOC',
  'Import.MOC.ID': 'MOC ID',

  'FR.Titles.FunctionalReview': 'Revue fonctionnelle',
  'FR.Actions.CompleteReview': 'Compléter la revue',
  'FR.Warnings.NotFoundFunctionalReview': 'Il n\'y a pas de revue fonctionnelle active pour les filtres sélectionnés. Pour démarrer une nouvelle revue fonctionnelle, cliquez sur le bouton créer.',
  'FR.Warnings.CannotStartFunctionalReview': 'Veuillez sélectionner un actif et un type de revue pour démarrer une revue fonctionnelle',
  'FR.Titles.ChecklistSections': 'Sections du plan de tâches',
  'FR.Titles.CreateNewSection': 'Créer une nouvelle section',
  'FR.Titles.CreateNewSubSection': 'Créer une nouvelle sous-section',
  'FR.Titles.ManageChecklist': 'Gérer le contenu de {{ Description }}',
  'FR.Forms.Labels.ReviewType': 'Type de revue',
  'FR.Forms.Labels.Description': 'Description',
  'FR.Tables.Headers.ID': 'ID',
  'FR.Tables.Headers.Priority': 'Priorité',
  'FR.Tables.Headers.Action': 'Action',
  'FR.Tables.Headers.Comment': 'Commentaire',
  'FR.Tables.Headers.UpdatedBy': 'Mis à jour par',
  'FR.Tables.Headers.Answer': 'Réponse',
  'FR.Tables.Headers.Question': 'Question',
  'FR.Tables.Headers.Code': 'Code',
  'FR.Tables.Headers.ReviewType': 'Type de revue',
  'FR.Tables.Headers.Description': 'Description',
  'FR.Actions.CreateNewItem': 'Créer un nouvel élément',
  'FR.Actions.BackToChecklists': 'Retour aux listes de contrôle',
  'FR.Titles.CreateChecklistItem': 'Créer un élément de liste de contrôle',
  'FR.Actions.BackToChecklistsManage': 'Retour à la gestion des listes de contrôle',
  'FR.Titles.EditChecklistItem': 'Modifier un élément de liste de contrôle',
  'FR.Titles.ConfigureActionItem': 'Configurer un élément d\'action',
  'FR.Titles.ConfigureComment': 'Configurer un commentaire',
  'FR.Forms.Labels.Action': 'Action',
  'FR.Forms.Labels.SubSection': 'Sous-section',
  'FR.Forms.Labels.Comment': 'Commentaire',
  'FR.Forms.Labels.Priority': 'Priorité',
  'FR.Forms.Errors.InputRequired': 'Ce champ est requis',
  'FR.Forms.Errors.RepeatedReviewType': 'Ce type de revue a déjà été pris',
  'FR.Forms.Errors.ReviewTypeMaxLength': 'Le type de revue ne doit comporter que {{maxlength.requiredLength}} caractères',
  'FR.Titles.CreateChecklist': 'Créer une liste de contrôle',
  'FR.SubTitles.ReviewTypeWarning': '[Note]:&nbsp;Le type de revue doit être unique et ne peut pas être renommé après la création de la liste de contrôle.',
  'FR.Errors.UnavailableMOC': 'Veuillez utiliser l\'outil MOC pour accéder à la revue fonctionnelle.',
  'FR.Errors.BuAssetNotSelected': 'Veuillez sélectionner une unité d\'affaires et un actif',
  'FR.Errors.ReviewError': 'Une erreur s\'est produite lors de la finalisation de la revue',
  'FR.Forms.Labels.SectionDescription': 'Description de la section',
  'FR.Forms.Labels.SubsectionDescription': 'Description de la sous-section',
  'FR.Messages.CommentAdded': 'Commentaire ajouté!',
  'FR.Messages.CommentUpdated': 'Commentaire mis à jour!',
  'FR.Messages.CommentDeleted': 'Commentaire supprimé!',
  'FR.Messages.ActionItemAdded': 'Élément d\'action ajouté!',
  'FR.Messages.ActionItemUpdated': 'Élément d\'action mis à jour!',
  'FR.Messages.ActionItemDeleted': 'Élément d\'action supprimé!',
  'FR.Messages.ResponseAdded': 'Réponse ajoutée!',
  'FR.Messages.ResponseAnswered': 'Réponse fournie!',
  'FR.Messages.ResponseRemoved': 'Réponse supprimée!',
  'FR.Messages.ChecklistCreated': 'Liste de contrôle créée',
  'FR.Messages.ChecklistUpdated': 'Liste de contrôle mise à jour',
  'FR.Messages.ChecklistSectionUpdated': 'Section de liste de contrôle mise à jour',
  'FR.Messages.ChecklistSubSectionUpdated': 'Sous-section de liste de contrôle mise à jour',
  'FR.Messages.ChecklistItemCreated': 'Élément de liste de contrôle créé',
  'FR.Messages.ChecklistItemUpdated': 'Élément de liste de contrôle mis à jour',
  'FR.Actions.Add': 'Ajouter',
  'FR.Actions.Create': 'Créer',
  'FR.Actions.Save': 'Enregistrer',
  'FR.Actions.Cancel': 'Annuler',
  'FR.Messages.ReviewCompleted': 'Revue complétée avec succès',
  'FR.Dialogs.Actions.Yes': 'Oui',
  'FR.Dialogs.Actions.No': 'Non',
  'FR.Dialogs.Title.Delete': 'Confirmer la suppression',
  'FR.Dialogs.Description.Delete': 'Souhaitez-vous supprimer?',
  'FR.Titles.EditChecklistSection': 'Modifier une section de liste de contrôle',
  'FR.Titles.EditChecklistSubSection': 'Modifier une sous-section de liste de contrôle',
  'FR.Forms.Labels.Code': 'Code',
  'FR.Forms.Labels.CreatedBy': 'Créé par',
  'FR.Forms.Labels.UpdatedDate': 'Date de mise à jour',
  'FR.Forms.Labels.UpdatedBy': 'Mis à jour par',
  'FR.Forms.Labels.ShouldAddCommentToQuestion': 'L\'utilisateur doit ajouter un commentaire à toute question répondue par \'N/A\'',
  'FR.Forms.Labels.AddQuestion': 'Ajouter une question',
  'FR.Titles.LastModification': 'Dernière modification',
  'FR.Titles.Checklist': 'Listes de contrôle',
  'FR.Filters.BusinessUnit': 'Unité d\'affaires',
  'FR.Filters.TaskPlan': 'Plan de tâches',
  'FR.Actions.CreateNewChecklist': 'Créer nouveau',
  'FR.Actions.Edit': 'Modifier',
  'FR.Actions.Manage': 'Gérer',
  'FR.Actions.Delete': 'Supprimer',
  'FR.Titles.MOC': 'MOC',
  'FR.Titles.EditChecklist': 'Modifier une liste de contrôle',
  'FR.Dialogs.Title.ImportChecklist': 'Importer une liste de contrôle',
  'FR.Forms.Labels.ChecklistType': 'Sélectionner un type de liste de contrôle',
  'FR.Dialogs.Actions.Confirm': 'Confirmer',
  'FR.Dialogs.Actions.Cancel': 'Annuler',
  'FR.Messages.ChecklistImported': 'La liste de contrôle a été importée avec succès!',
  'FR.Filters.ReviewType': 'Type de revue',
  'FR.Actions.GenerateReport': 'Générer un rapport',
  'Alerts.OutdatedApp.Message': 'Veuillez noter que l\'application mobile actuelle sera bientôt mise hors service. Nous encourageons tous les utilisateurs à mettre à jour vers la nouvelle application mobile \'PSSR 3\' dès que possible.',
  'FR.Errors.ReportError': 'Une erreur s\'est produite lors de la génération du rapport',
  'FR.Messages.ReportGenerated': 'Rapport généré avec succès',
  'FR.Warnings.CannotComplete': 'Répondez à toutes les questions pour compléter la revue fonctionnelle',
  'FR.Forms.Errors.DescriptionMaxLength': 'La description ne doit comporter que {{maxlength.requiredLength}} caractères',
  'PSSR.NotRegistered.Messages.Reload': 'Si vous consultez cette page mais avez déjà accès, veuillez cliquer sur le lien suivant pour recharger, sinon contactez le support.',
  'PSSR.NotRegistered.Actions.Reload': 'Recharger',
  'OrgUsers.Forms.Labels.DisplayInactiveUsers': 'Afficher les utilisateurs inactifs',
  'OrgUsers.Actions.ActivateUser': 'Activer',
  'OrgUsers.Actions.DeleteUser': 'Supprimer',

};
